<template>
    <!-- CONTENT ================================================== -->
    <div class="login-page">

        <!-- ===== ANIMATED BACKGROUND ===== -->
        <div class="bg-slider">
            <div class="slide" v-for="(slide, index) in slides" :key="index" :class="{ active: index === currentSlide }"
                :style="{ backgroundImage: 'url(' + slide + ')' }"></div>
        </div>
        <div class="bg-overlay"></div>
        <div class="bg-grid"></div>
        <div class="bg-particles">
            <span></span><span></span><span></span><span></span>
            <span></span><span></span><span></span><span></span>
        </div>

        <!-- ===== TOP HEADER ===== -->
        <header class="top-header">
            <img src="https://sshsbu.e-planningbmd.id/assets/images/bandung.png" alt="Logo Kabupaten Bandung">
            <div class="brand-text">
                <strong>PERSEDIAAN</strong>
                <span>KABUPATEN BANDUNG</span>
            </div>
        </header>

        <!-- ===== MAIN CONTENT ===== -->
        <div class="page-content">

            <!-- ---- HERO (left) ---- -->
            <div class="hero">
                <span class="hero-badge">🌐 Sistem Informasi</span>

                <h1>SISTEM INFORMASI<br><span class="grad-text">PERSEDIAAN BMD</span></h1>

                <p class="hero-desc">
                    Sistem Informasi Persediaan Barang Milik Daerah Kabupaten Bandung <br>Mendukung
                    pengelolaan persediaan yang akurat, transparan, dan akuntabel.
                </p>

                <!-- Feature panel -->
                <div class="feature-panel">
                    <div class="feature-item">
                        <div class="feature-icon" style="background:#e8f0fe;">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2f6fed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="5" r="2.2"></circle><circle cx="5" cy="17" r="2.2"></circle><circle cx="19" cy="17" r="2.2"></circle><path d="M12 7.2 7 15.2"></path><path d="M12 7.2 17 15.2"></path><path d="M7.2 17h9.6"></path></svg>
                        </div>
                        <h4>Terintegrasi</h4>
                        <p>Seluruh proses pengelolaan persediaan terhubung dalam satu sistem</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon" style="background:#e6f7ec;">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </div>
                        <h4>Transparan</h4>
                        <p>Informasi persediaan dikelola secara terbuka dan dapat dipertanggungjawabkan</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon" style="background:#fff4e0;">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3.5 2"></path></svg>
                        </div>
                        <h4>Realtime</h4>
                        <p>Data dan status persediaan selalu diperbarui secara langsung</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon" style="background:#f2eaff;">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M8 12.5 10.5 15 15.5 9.5"></path></svg>
                        </div>
                        <h4>Andal</h4>
                        <p>Proses kerja yang konsisten, akurat, dan dapat diandalkan</p>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon" style="background:rgba(4,96,96,0.08);">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#046060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>
                        </div>
                        <h4>Aman</h4>
                        <p>Data terlindungi dengan sistem keamanan berlapis</p>
                    </div>
                </div>

                <!-- Pejabat strip -->
                <div class="pejabat-strip">
                    <div class="pejabat-photos">
                        <div class="photo-circle photo-kadis">
                            <img src="https://penatausahaan.e-planningbmd.id/assets/images/bkad.png" alt="Kepala BKAD">
                        </div>
                    </div>
                    <div class="pejabat-info">
                        <p class="pejabat-name">BADAN KEUANGAN DAN ASET DAERAH</p>
                        <p class="pejabat-role">KABUPATEN BANDUNG</p>
                    </div>
                </div>

                <div class="slider-dots">
                    <span class="dot" v-for="(slide, index) in slides" :key="index"
                        :class="{ active: index === currentSlide }" @click="goToSlide(index)"></span>
                </div>
            </div>

            <!-- ---- LOGIN CARD (right) ---- -->
            <div class="login-panel">
                <div class="login-glow"></div>
                <div class="login-card">
                    <div class="card-icon-badge">
                        <img src="https://sshsbu.e-planningbmd.id/assets/images/bandung.png" alt="Logo Kabupaten Bandung">
                    </div>

                    <div class="login-header">
                        <p class="welcome-label">Selamat Datang di</p>
                        <h2>Persediaan Kabupaten Bandung</h2>
                        <h6 class="periode-label" v-if="checkDomain != 'persediaan.e-planningbmd.id'">( Tahun 2026 )</h6>
                        <!-- HIDE SEMENTARA -->
                        <h6 class="periode-label" v-if="checkDomain == 'persediaan.e-planningbmd.id'">( Tahun 2025 )</h6>
                        <!-- HIDE SEMENTARA -->
                        <span class="header-divider"></span>
                    </div>

                    <form v-on:submit.prevent="handleSubmit">

                        <!-- Username -->
                        <div class="form-group input-icon">
                            <span class="input-prefix">👤</span>
                            <input type="text" class="input-field" :class="{ 'is-invalid': submitted && $v.username.$error }"
                                v-model="username" placeholder="Masukan username" autocomplete="off">
                            <div v-if="submitted && !$v.username.required" class="invalid-feedback">Username is required</div>
                        </div>

                        <!-- Password -->
                        <div class="form-group input-icon">
                            <span class="input-prefix">🔒</span>
                            <input :type="showPassword ? 'text' : 'password'" class="input-field"
                                :class="{ 'is-invalid': submitted && $v.password.$error }"
                                v-model="password" placeholder="Masukan password">
                            <i class="toggle-password" @click="showPassword = !showPassword">{{ showPassword ? '🙈' : '👁️' }}</i>
                            <div v-if="submitted && !$v.password.required" class="invalid-feedback">Password is required</div>
                        </div>

                        <button v-if="!loading" type="submit" class="btn-login">
                            LOGIN <span class="arrow">→</span>
                        </button>
                        <button v-else disabled class="btn-loading" type="button">
                            Loading...
                        </button>

                        <div v-if="checkDomain != 'persediaan.e-planningbmd.id'" class="alert alert-warning alert-bordered pd-y-15" role="alert">
                            <div class="d-sm-flex align-items-center justify-content-start">
                                <div class="mg-t-20 mg-sm-t-0 text-center">
                                    <p class="text-dark text-center mg-b-0 tx-gray">Masuk ke Transaksi <a href="https://persediaan.e-planningbmd.id/" class="text-center text-info"><b>Transaksi 2025</b></a></p>
                                </div>
                            </div>
                        </div>

                        <!-- HIDE SEMENTARA -->
                        <div v-if="checkDomain == 'persediaan.e-planningbmd.id'" class="alert alert-info alert-bordered pd-y-15" role="alert">
                            <div class="d-sm-flex align-items-center justify-content-start">
                                <div class="mg-t-20 mg-sm-t-0 text-center">
                                    <p class="text-dark text-center mg-b-0 tx-gray">Kembali ke <a href="https://persediaanbmd.bandungkab.go.id/" class="text-center text-info"><b>Transaksi 2026</b></a></p>
                                </div>
                            </div>
                        </div>
                        <!-- HIDE SEMENTARA -->

                    </form>

                    <div class="footer-note">
                        <p>© {{ new Date().getFullYear() }} Badan Keuangan dan Aset Daerah<br>Kabupaten Bandung</p>
                    </div>
                </div>
            </div>

        </div>

        <footer class="page-footer">
            Sistem Informasi Persediaan &mdash; Kabupaten Bandung
        </footer>
    </div> <!-- / .login-page -->
</template>

<style scoped>
    * { box-sizing: border-box; }

    .login-page {
        position: fixed;
        inset: 0;
        width: 100%;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        isolation: isolate;
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        background: #010f0f;
    }

    /* ===================== BACKGROUND ===================== */
    .bg-slider { position: absolute; inset: 0; z-index: -3; }

    .bg-slider .slide {
        position: absolute; inset: 0;
        background-size: cover; background-position: center;
        opacity: 0; transform: scale(1.06);
        transition: opacity 1.8s ease, transform 8s ease;
        filter: saturate(1.05);
    }
    .bg-slider .slide.active { opacity: 1; transform: scale(1); }

    .bg-overlay {
        position: absolute; inset: 0; z-index: -2;
        background:
            radial-gradient(ellipse 900px 700px at 12% 30%, rgba(10,144,144,0.35), transparent 60%),
            linear-gradient(115deg, rgba(1,15,15,0.78) 0%, rgba(2,48,48,0.6) 32%, rgba(2,48,48,0.3) 55%, rgba(1,15,15,0.5) 78%, rgba(1,15,15,0.8) 100%);
    }

    @keyframes gridDrift {
        0% { background-position: 0 0; }
        100% { background-position: 60px 60px; }
    }
    .bg-grid {
        position: absolute; inset: 0; z-index: -1; pointer-events: none;
        background-image:
            linear-gradient(rgba(93,196,196,0.07) 1px, transparent 1px),
            linear-gradient(90deg, rgba(93,196,196,0.07) 1px, transparent 1px);
        background-size: 42px 42px;
        animation: gridDrift 14s linear infinite;
        mask-image: radial-gradient(ellipse 80% 70% at 30% 40%, black 20%, transparent 75%);
        -webkit-mask-image: radial-gradient(ellipse 80% 70% at 30% 40%, black 20%, transparent 75%);
    }

    @keyframes floatDot {
        0%, 100% { transform: translateY(0) translateX(0); opacity: .25; }
        50% { transform: translateY(-26px) translateX(10px); opacity: .8; }
    }
    .bg-particles { position: absolute; inset: 0; z-index: -1; pointer-events: none; }
    .bg-particles span {
        position: absolute; width: 4px; height: 4px; border-radius: 50%;
        background: #5dc4c4;
        box-shadow: 0 0 8px 2px rgba(93,196,196,0.6);
        animation: floatDot 6s ease-in-out infinite;
    }
    .bg-particles span:nth-child(1)  { top: 18%; left: 8%;  animation-delay: 0s; }
    .bg-particles span:nth-child(2)  { top: 32%; left: 22%; animation-delay: 1.1s; }
    .bg-particles span:nth-child(3)  { top: 60%; left: 14%; animation-delay: 2.2s; }
    .bg-particles span:nth-child(4)  { top: 74%; left: 30%; animation-delay: .6s; }
    .bg-particles span:nth-child(5)  { top: 22%; left: 40%; animation-delay: 1.8s; }
    .bg-particles span:nth-child(6)  { top: 46%; left: 6%;  animation-delay: 2.6s; }
    .bg-particles span:nth-child(7)  { top: 85%; left: 46%; animation-delay: 3.2s; }
    .bg-particles span:nth-child(8)  { top: 10%; left: 55%; animation-delay: 1.4s; }

    /* ===================== TOP HEADER ===================== */
    .top-header {
        position: relative; z-index: 2;
        display: flex; align-items: center; gap: 12px;
        padding: 26px 48px 0;
        background: transparent !important;
    }
    .top-header img {
        width: 44px; height: 44px; object-fit: contain;
        filter: drop-shadow(0 2px 6px rgba(0,0,0,0.5));
    }
    .top-header .brand-text strong {
        display: block; color: #fff; font-size: 17px; letter-spacing: 2px; font-weight: 800;
    }
    .top-header .brand-text span {
        display: block; color: #5dc4c4; font-size: 10.5px; letter-spacing: 1.5px; font-weight: 600;
    }

    /* ===================== MAIN CONTENT ===================== */
    .page-content {
        position: relative; z-index: 2;
        flex: 1;
        width: 100%; max-width: 1360px; margin: 0 auto;
        display: flex; align-items: center; justify-content: space-between;
        gap: 36px;
        padding: 40px 48px;
    }

    /* ---- Hero (left) ---- */
    .hero { flex: 1; min-width: 0; max-width: 640px; }

    .hero-badge {
        display: inline-flex; align-items: center; gap: 8px;
        padding: 7px 14px; border-radius: 999px;
        background: rgba(93,196,196,0.12);
        border: 1px solid rgba(93,196,196,0.4);
        color: #5dc4c4;
        font-size: 11px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;
        margin-bottom: 20px;
    }

    .hero h1 {
        margin: 0; color: #fff; font-weight: 800;
        font-size: 44px; line-height: 1.15;
        text-shadow: 0 4px 20px rgba(0,0,0,0.4);
    }
    .hero h1 .grad-text {
        background: linear-gradient(90deg, #5dc4c4, #a8f0e6 45%, #0a9090);
        -webkit-background-clip: text; background-clip: text; color: transparent;
    }

    .hero-desc {
        margin-top: 16px; max-width: 480px;
        color: rgba(255,255,255,0.78); font-size: 14.5px; line-height: 1.7;
    }

    /* Feature panel (white floating card) */
    .feature-panel {
        margin-top: 30px;
        background: rgba(255,255,255,0.98);
        border-radius: 20px;
        padding: 20px;
        display: flex; gap: 14px;
        box-shadow: 0 20px 50px rgba(0,0,0,0.35);
    }
    .feature-item { flex: 1; min-width: 0; }
    .feature-icon {
        width: 34px; height: 34px; border-radius: 50%;
        display: flex; align-items: center; justify-content: center;
        margin-bottom: 10px;
    }
    .feature-item h4 {
        margin: 0 0 4px; font-size: 12px; font-weight: 700; color: #16211f;
    }
    .feature-item p {
        margin: 0; font-size: 10px; color: #7a8785; line-height: 1.5;
    }

    /* Pejabat strip */
    .pejabat-strip {
        margin-top: 20px;
        display: inline-flex; align-items: center; gap: 14px;
        background: rgba(1,15,15,0.55);
        border: 1px solid rgba(93,196,196,0.3);
        border-radius: 16px;
        padding: 10px 18px 10px 10px;
        backdrop-filter: blur(6px);
    }
    .pejabat-photos { display: flex; align-items: center; flex-shrink: 0; }
    .photo-circle {
        width: 46px; height: 46px; border-radius: 50%; overflow: hidden;
        background: rgba(255,255,255,0.06);
        box-shadow: 0 4px 12px rgba(0,0,0,0.5);
        flex-shrink: 0;
    }
    .photo-circle img { width: 100%; height: 100%; object-fit: cover; }
    .photo-circle.photo-kadis {
        border: 2px solid #5dc4c4;
        z-index: 1;
    }
    .pejabat-info { line-height: 1.35; }
    .pejabat-info p { margin: 0; }
    .pejabat-info .pejabat-name { color: #fff; font-size: 11px; font-weight: 600; }
    .pejabat-info .pejabat-role { color: #5dc4c4; font-size: 9px; text-transform: uppercase; letter-spacing: .6px; font-weight: 600; }

    /* Slider dots */
    .slider-dots {
        display: flex; gap: 7px; margin-top: 22px;
    }
    .dot {
        width: 8px; height: 8px; border-radius: 50%;
        background: rgba(255,255,255,0.3);
        border: 1.5px solid rgba(255,255,255,0.45);
        cursor: pointer; transition: background .3s, transform .3s;
    }
    .dot.active { background: #5dc4c4; border-color: #5dc4c4; transform: scale(1.25); }

    /* ---- Login panel (right) ---- */
    .login-panel { position: relative; flex-shrink: 0; width: 380px; }

    .login-glow {
        position: absolute; inset: -30px;
        background: radial-gradient(circle at 30% 20%, rgba(93,196,196,0.35), transparent 60%);
        filter: blur(30px); z-index: 0;
    }

    .login-card {
        position: relative; z-index: 1;
        background: rgba(255,255,255,0.98);
        border-radius: 26px;
        padding: 46px 32px 30px;
        box-shadow: 0 30px 80px rgba(0,0,0,0.55), 0 0 0 1px rgba(93,196,196,0.25);
    }

    .card-icon-badge {
        position: absolute; top: -32px; left: 50%; transform: translateX(-50%);
        width: 64px; height: 64px; border-radius: 50%;
        background: #fff;
        display: flex; align-items: center; justify-content: center;
        border: 4px solid #fff;
        box-shadow: 0 8px 20px rgba(4,96,96,0.25);
        z-index: 2;
    }
    .card-icon-badge img {
        width: 52px; height: 52px; border-radius: 50%; object-fit: cover;
    }

    .login-header { text-align: center; margin-bottom: 22px; }
    .login-header .welcome-label { font-size: 11.5px; color: #8a9694; margin: 0 0 3px; }
    .login-header h2 {
        margin: 0; font-size: 18px; font-weight: 800; color: #023030; letter-spacing: .3px;
    }
    .login-header .periode-label { margin: 4px 0 0; font-size: 12px; font-weight: 600; color: #046060; }
    .header-divider {
        display: block; width: 40px; height: 3px; margin: 12px auto 0;
        background: linear-gradient(90deg, #046060, #5dc4c4);
        border-radius: 2px;
    }

    .form-group { margin-bottom: 14px; }

    .input-icon { position: relative; }
    .input-icon .input-prefix {
        position: absolute; left: 12px; top: 15px;
        font-size: 14px; line-height: 1; pointer-events: none; opacity: .55;
    }
    .input-icon .input-field {
        width: 100%; padding: 11px 36px 11px 36px;
        border-radius: 10px; border: 1.5px solid #e2e8e7; outline: none;
        font-size: 13px; color: #333; background: #f7fbfb;
        transition: border-color .25s, box-shadow .25s, background .25s;
    }
    .input-icon .input-field:focus {
        border-color: #046060;
        box-shadow: 0 0 0 3px rgba(4,96,96,0.12);
        background: #fff;
    }
    .input-icon .input-field.is-invalid { border-color: #dc3545; }
    .invalid-feedback { display: block; font-size: 11px; color: #dc3545; margin-top: 4px; }
    .toggle-password {
        position: absolute; right: 12px; top: 15px;
        cursor: pointer; font-size: 14px; line-height: 1; user-select: none; opacity: .6;
    }

    /* Buttons */
    .btn-login {
        width: 100%; padding: 12px; border-radius: 10px; border: none;
        background: linear-gradient(135deg, #046060, #0a9090);
        color: #fff; font-weight: 700; letter-spacing: 1.5px; font-size: 13px;
        cursor: pointer; margin-top: 8px;
        display: flex; align-items: center; justify-content: center; gap: 8px;
        transition: transform .2s, box-shadow .2s;
    }
    .btn-login:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(4,96,96,0.5); }
    .btn-login .arrow { transition: transform .2s; }
    .btn-login:hover .arrow { transform: translateX(3px); }

    .btn-loading {
        width: 100%; padding: 12px; border-radius: 10px; border: none;
        background: linear-gradient(135deg, #667, #889);
        color: #fff; font-weight: 700; letter-spacing: 1px; font-size: 13px;
        margin-top: 8px; cursor: not-allowed;
    }

    .alert-bordered { margin-top: 14px; border-radius: 10px; font-size: 11.5px; padding: 10px 12px; }

    .footer-note { text-align: center; margin-top: 18px; padding-top: 14px; border-top: 1px solid #eef2f2; }
    .footer-note p { font-size: 10px; color: #b8c2c0; line-height: 1.6; }

    /* ===================== PAGE FOOTER ===================== */
    .page-footer {
        position: relative; z-index: 2; text-align: center;
        padding: 14px 20px; font-size: 11px; color: rgba(255,255,255,0.55);
        border-top: 1px solid rgba(255,255,255,0.08);
        background: transparent !important;
    }

    /* ===================== RESPONSIVE ===================== */
    @media (max-width: 1080px) {
        .hero h1 { font-size: 34px; }
        .login-panel { width: 340px; }
    }

    @media (max-width: 900px) {
        .page-content { flex-direction: column; padding: 24px 24px 40px; text-align: center; }
        .hero { max-width: 100%; }
        .hero-badge { margin-left: auto; margin-right: auto; }
        .feature-panel { flex-wrap: wrap; justify-content: center; }
        .feature-item { flex: 1 1 45%; text-align: center; }
        .feature-icon { margin-left: auto; margin-right: auto; }
        .pejabat-strip { margin-left: auto; margin-right: auto; }
        .slider-dots { justify-content: center; }
        .login-panel { width: 100%; max-width: 400px; margin: 8px auto 0; }
    }

    @media (max-width: 480px) {
        .top-header { padding: 20px 20px 0; }
        .hero h1 { font-size: 26px; }
        .feature-item { flex: 1 1 100%; }
    }
</style>


<script>
    import axios from "axios";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: 'Signin',
        metaInfo: {
            title: 'Website Persediaan BMD Kabupaten Bandung',
            meta: [
            {
                name: 'description',
                content: 'Website Persediaan BMD Kabupaten Bandung'
            },
            {
                name: 'keywords',
                content: 'Persediaan, Kab Bandung, Kabupaten Bandung, Persediaan Kabupaten Bandung, Persediaan kab Bandung, Web Persediaan, Persediaan BMD'
            }
            ]
        },
        created() {
            const head = document.head;

            const metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            metaDescription.content = 'Website Persediaan BMD Kabupaten Bandung';

            const metaKeywords = document.createElement('meta');
            metaKeywords.name = 'keywords';
            metaKeywords.content = 'Persediaan, Kab Bandung, Kabupaten Bandung, Persediaan Kabupaten Bandung, Persediaan kab Bandung, Web Persediaan, Persediaan BMD';

            head.appendChild(metaDescription);
            head.appendChild(metaKeywords);

            this.check_domain();
        },
        mounted() {
            this.sliderTimer = setInterval(this.nextSlide, 4500);
        },
        beforeDestroy() {
            clearInterval(this.sliderTimer);
        },
        data() {
            return {
                username: "",
                password: "",
                submitted: false,
                checkDomain: '',
                showPassword: false,
                loading: false,
                slides: [
                    '/assets/images/satu.jpg',
                    '/assets/images/dua.jpg',
                    '/assets/images/tiga.jpg'
                ],
                currentSlide: 0,
                sliderTimer: null,
            }
        },
        validations: {
            username: {
                required
            },
            password: {
                required
            }
        },
        methods: {
            check_domain() {
                this.checkDomain = window.location.hostname;
                // this.checkDomain = 'persediaan.e-planningbmd.id';
                // this.checkDomain = 'persediaanbmd.bandungkab.go.id';
            },
            nextSlide() {
                this.currentSlide = (this.currentSlide + 1) % this.slides.length;
            },
            goToSlide(index) {
                clearInterval(this.sliderTimer);
                this.currentSlide = index;
                this.sliderTimer = setInterval(this.nextSlide, 4500);
            },
            handleSubmit() {
                this.submitted = true;
                this.$v.$touch();
                if (this.$v.$invalid) {
                    window.toastr.warning('Harap lengkapi form login', 'Ups!');
                    return;
                } else {
                    this.loading = true;
                    this.$http.post(this.$apiconfig + 'admin/auth/signin', {
                            username: this.username,
                            password: this.password
                        })
                        .then(response => {
                            if (response.data.status === "success") {
                                const getUser = response.data.user;
                                this.$router.push('/admin/dashboard');
                                if (getUser.require_twofactor == '1') {
                                    localStorage.setItem('name', getUser.fullname);
                                    localStorage.setItem('email', getUser.email);
                                    this.$router.push('/admin/twofactor');
                                } else {
                                    const token = getUser.key;
                                    localStorage.setItem('auth_token', token);
                                    axios.defaults.headers.common['Authorization'] = token;
                                    this.$router.push('/admin/dashboard');
                                }
                            } else {
                                this.loading = false;
                                window.toastr.error(response.data.message, 'Ups!');
                            }
                        })
                        .catch(function (error) {
                            // Swal.fire('Uh oh!', 'Please check your internet connection.', 'error')
                            console.debug("Login issue: " + error)
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
        }
    }
</script>
